import styled from '@emotion/styled';
import {
  Section,
  TitleAndDescription,
  token,
} from '@ferreri/prever-component-lib';
import { AccordionItem } from './AccordionItem';
import { getAllGroupsDependentRule } from '../plan-detail.store';
import { PlanVersionType } from './rules.types';

export const DependentRule = (props: PlanVersionType) => {
  if (!props.dependent_rule) return null;

  const allGroups = getAllGroupsDependentRule(
    props.dependent_rule,
    props.subscription_rule.dependents,
  );

  return (
    <Section>
      <TitleAndDescription title="Condições para dependentes" />
      <Container>
        <AccordionItem allGroups={allGroups} />
      </Container>
    </Section>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxSmall};
`;
